module.exports = __webpack_public_path__ + "static/media/vi_yan_yan.9b1f4391.jpg";